import { apiFetch } from '@/lib/api';
import { cachedFetch, invalidate, SHELL_CACHE_TTL_MS } from '@/lib/requestCache';

export type BotOperationalStatus = 'active' | 'paused' | 'offline';
export type BotStatusReason =
  | 'no_integration'
  | 'token_expired'
  | 'quota_cap'
  | 'trial_cap'
  | 'no_subscription'
  | 'manual'
  | null;

export interface BotStatusResponse {
  status: BotOperationalStatus;
  reason: BotStatusReason;
}

export const botStatusService = {
  /** F070: cached (30s TTL). */
  getStatus(opts?: { fresh?: boolean }): Promise<BotStatusResponse> {
    return cachedFetch('bot:status', () => apiFetch<BotStatusResponse>('/bot/status'), {
      ttlMs: SHELL_CACHE_TTL_MS,
      fresh: opts?.fresh,
    });
  },
  async pause(): Promise<BotStatusResponse> {
    const next = await apiFetch<BotStatusResponse>('/bot/pause', { method: 'POST' });
    invalidate('bot:status');
    return next;
  },
  async resume(): Promise<BotStatusResponse> {
    const next = await apiFetch<BotStatusResponse>('/bot/resume', { method: 'POST' });
    invalidate('bot:status');
    return next;
  },
};
